let sr_quick_buy_container = document.querySelector('.sr-quick-popup-content');
let productCache = {};

document.addEventListener("click", (e) => {
    const sr_popup =document.getElementById('quickBuyPopup');
    const sr_closeBtn = document.getElementById('quickClosePopup');
    const sr_quick_buy_content = document.querySelector('.sr-quick-popup-content');
    const sr_quick_popup_details = document.querySelector('.sr-quick-popup-view-details');
    const sr_quick_popup_link = document.querySelector('.sr-quick-popup-link');
    if (e.target.closest(".sr-quick-buy-btn")) {
        e.preventDefault();
        const item = e.target.closest(".sr-quick-buy-btn");
        const p_handle = item.dataset.handle;
        console.log("show!", p_handle);
        //sr_popup.style.display = "block";
        sr_quick_buy_content.innerHTML = '<div class="sr-quick-loading"><span class="spinner"></span></div>';
        //console.log(collectionType);
        //console.log(item.dataset.productType);
        
        if(collectionType && item.dataset.productType !== collectionType && item.dataset.productType !== undefined) {
          collectionType = item.dataset.productType;
        }

        //console.log(collectionType);
        sr_popup.classList.add('active');
        sr_popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (p_handle) {
            if (productCache[p_handle]) {
              sr_quick_buy_container.innerHTML = productCache[p_handle];
              setTimeout(() => {
                if(applyGlobalBasePriceAdjustments){
                  applyGlobalBasePriceAdjustments();
                }
              }, 200);
              return;
            }
            quickBuyProduct(p_handle);
            setTimeout(() => {
              if(applyGlobalBasePriceAdjustments){
                applyGlobalBasePriceAdjustments();
              }

              if (typeof MarkdownPricePro !== "undefined" && typeof MarkdownPricePro.run === "function") {
                MarkdownPricePro.run();
              }

            }, 3000);
        }
    }
    if (e.target.closest('#quickClosePopup')) {
        sr_popup.classList.remove('active');
        sr_popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        sr_quick_buy_content.innerHTML = '';
    }
    if (e.target === sr_popup) {
        sr_popup.classList.remove('active');
        sr_popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        sr_quick_buy_content.innerHTML = '';
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Close button
    const sr_closeBtn = document.getElementById('quickClosePopup');
    const sr_quick_buy_content = document.querySelector('.sr-quick-popup-content');
    if(sr_closeBtn) {
      sr_closeBtn.addEventListener('click', function () {
        const sr_popup =document.getElementById('quickBuyPopup');
        sr_popup.classList.remove('active');
        sr_popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        sr_quick_buy_content.innerHTML = '';
    });
    }
});

function quickBuyProduct(handle) {
    fetch(`/products/${handle}`)
    .then(response => response.text())
    .then(html => {
        //console.log(html);
        quickBuyProductInfo(html, handle);
    });
}

function quickBuyProductInfo(html, handle) {
  const new_content = new DOMParser().parseFromString(html, "text/html");
  const nc = new_content.querySelector("product-form");

  if (!nc) {
    console.error("Error: Product form not found in the response!");
    return;
  }

  if (!sr_quick_buy_container) {
    console.error("Error: Popup container not found!");
    return;
  }

  sr_quick_buy_container.innerHTML = "";
  sr_quick_buy_container.innerHTML = nc.outerHTML;
  productCache[handle] = nc.outerHTML;

  setTimeout(function () {
    const sr_popup_dpcr = document.querySelector(".sr-quick-popup-content .detail.product-column-right");
    const temp = document.createElement("div");
    temp.innerHTML = `
      <div class="sr-quick-popup-view-details">
        <a class="sr-quick-popup-link" href="/products/${handle}">
          View Details 
          <span>
            <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.23134 11.4133L6.35667 6.28666L1.23004 1.16003" stroke="black" stroke-width="1.86" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </a>
      </div>
    `;
    if (sr_popup_dpcr) sr_popup_dpcr.appendChild(temp.firstElementChild);

    const formEl = sr_quick_buy_container.querySelector("product-form");
    if (formEl) {
      if (typeof ProductForm !== "undefined") {
        new ProductForm(formEl);
      } else if (typeof theme !== "undefined" && typeof theme.Product !== "undefined") {
        new theme.Product(formEl);
      }
    }

    const scripts = sr_quick_buy_container.querySelectorAll("script");
    scripts.forEach(oldScript => {
      const newScript = document.createElement("script");
      if (newScript.src) {
        if (oldScript.src) {
          newScript.src = oldScript.src;
        } else {
          newScript.textContent = oldScript.textContent;
        }
        document.body.appendChild(newScript);
        document.body.removeChild(newScript);
      }
    });
    
    

    if (typeof yotpoWidgetsContainer !== "undefined") {
      yotpoWidgetsContainer.initWidgets();
    }
  }, 200);
}
  function applyGlobalBasePriceAdjustments() {
      document.querySelectorAll('.product-form [data-product-collections] .money').forEach((element) => {
        const productWrapper = element.closest('[data-product-collections]');
        if (!productWrapper) return;
        // Skip if already has a markdown applied or if not an "original" or "default-title" variant
        if (
          productWrapper.dataset.discountedPrice !== undefined ||
          element.closest('[data-markdown-discounted="true"]') ||
          element.getAttribute('data-markdown-discounted') === 'true' ||
          (
            element.closest('[data-current]') &&
            !['original', 'default-title','original-standard','original-small'].includes(element.closest('[data-current]').dataset.current.toLowerCase())
          )
        ) {
          return;
        }
  
        const collections = productWrapper.dataset.productCollections
          ? productWrapper.dataset.productCollections.split(' ')
          : [];
  
        const variantTitle = productWrapper.dataset.current
          ? productWrapper.dataset.current.toLowerCase()
          : '';
  
        const priceText = element.textContent;
        const curr = theme.globals.userCurrency === 'GBP' ? '£' : '$';
  
        let prices = priceText.match(/[-+]?[0-9]*\.?[0-9]+/g);
        if (!prices) prices = [];
  
        let price_value = parseFloat(prices[0] || 0);
  
        // Apply adjustment
        let adjustedPrice = MarkdownPricePro.applyBasePriceAdjustment(price_value, collections, variantTitle);
  
        if (adjustedPrice !== price_value) {
          // If inside a product variant wrapper → no decimals
          const isProductVariant = productWrapper.hasAttribute('data-current');
          let displayPrice = isProductVariant
            ? `${curr}${Math.round(adjustedPrice)}`
            : `${curr}${adjustedPrice.toFixed(2)}`;
  
          element.textContent = displayPrice;
          // store adjusted price for downstream calculations
          productWrapper.dataset.realPriceAdjusted = adjustedPrice * 100; 
        }
      });
  }